import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { StandardsProvider } from './context';
import StandardDetail from './Detail';
import WrittenDirectives from './WrittenDirectives';

const Standards = () => {
  const { id: accreditationId, versionId } = useParams();

  return (
    <StandardsProvider
      accreditingBodyId={accreditationId!}
      versionId={versionId!}
    >
      <Routes>
        <Route
          path=':standardId/jurisdiction/:jurisdictionId/written-directives/*'
          element={<WrittenDirectives />}
        />
        <Route
          path=':standardId'
          element={<StandardDetail />}
        />
        <Route
          path=''
          element={<StandardDetail />}
        />
      </Routes>
    </StandardsProvider>
  );
};

export default Standards;
